"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideBarItem = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var react_1 = require("react");
var theme_1 = require("../../theme");
var Icon_1 = require("../Icon");
var Typography_1 = require("../Typography");
var SideBarItem = function (_a) {
    var _b, _c;
    var name = _a.name, link = _a.link, icon = _a.icon, label = _a.label, badge = _a.badge, ariaLabel = _a.ariaLabel, selected = _a.selected, testId = _a.testId, onClick = _a.onClick, disabled = _a.disabled, _d = _a.titleClassName, titleClassName = _d === void 0 ? 'squid-whitespace-nowrap' : _d;
    var bgStateColors = (0, theme_1.useBackgroundStateColors)();
    var bgActiveStateColors = (0, theme_1.useBackgroundStateActiveColors)();
    var handleClick = (0, react_1.useCallback)(function () {
        onClick === null || onClick === void 0 ? void 0 : onClick(link);
    }, [onClick, link]);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ id: name, "data-testid": "".concat(testId, "-item-").concat(name), onClick: !disabled && !selected ? handleClick : undefined, className: (0, classnames_1.default)('squid-flex', 'squid-items-center', 'squid-justify-between', 'squid-p-component-step-padding', 'squid-rounded-component-step-border-radius', 'squid-w-full', (_b = {},
            _b[bgStateColors.base] = !disabled,
            _b[bgActiveStateColors.base] = selected,
            _b['squid-cursor-pointer'] = !disabled,
            _b)), "aria-label": ariaLabel, tabIndex: 0, role: "button", "aria-disabled": disabled }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "squid-flex squid-gap-component-step-space squid-items-center" }, { children: [(0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: icon, size: "md", fill: selected ? 'on-base-active' : 'base' }), (0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ as: "h6", size: "base", strong: true, color: selected ? 'on-base-active' : 'weaker', className: (0, classnames_1.default)(titleClassName, (_c = {},
                            _c['squid-cursor-pointer'] = !disabled,
                            _c)) }, { children: label }))] })), badge] })));
};
exports.SideBarItem = SideBarItem;
